import { GET_FuelType_LIST_Register } from "../../../../constants/ActionTypes";
import { zeroPad } from "../../../../util/DaFrameword";


const InitialValue={
    FuelTypeList:[]
}

function FuelTypeRegister(state=InitialValue,action){

    switch (action.type) {
        case GET_FuelType_LIST_Register:
            return {
                ...state,
                    FuelTypeList:action.payload.map(x=>({
                    Id:zeroPad(x.id,8),
                    description:x.description,
                    active:x.active                
                })) 
            }
        default:
           return state
    }  

}

export default FuelTypeRegister;